export default "__VITE_ASSET__BoTCAKJQ__"